import { clsx } from "clsx";

import * as styles from "./ClothingTagFilter.module.scss";

export const ALL_CLOTHING_TAG_ID = "all";

export interface ClothingTagFilterOption {
  id: string;
  name: string;
}

interface ClothingTagFilterProps {
  tags: ClothingTagFilterOption[];
  activeId: string;
  onChange: (id: string) => void;
}

export function ClothingTagFilter({
  tags,
  activeId,
  onChange,
}: ClothingTagFilterProps) {
  return (
    <div className={styles.clothingTagFilter}>
      <button
        type="button"
        className={clsx(styles.clothingTagFilterItem, {
          [styles.clothingTagFilterItemActive]:
            ALL_CLOTHING_TAG_ID === activeId,
        })}
        onClick={() => onChange(ALL_CLOTHING_TAG_ID)}
      >
        全部
      </button>

      {tags.map((tag) => {
        const isActive = tag.id === activeId;
        return (
          <button
            key={tag.id}
            type="button"
            className={clsx(styles.clothingTagFilterItem, {
              [styles.clothingTagFilterItemActive]: isActive,
            })}
            onClick={() => onChange(tag.id)}
          >
            {tag.name}
          </button>
        );
      })}
    </div>
  );
}
